import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useThemeContext } from "../../context/themeContext";

const Tabs = ({ tabs, currentTab, setCurrentTab, selectedParticipant }) => {
  const { theme } = useThemeContext();

  return (
    <div
      role="tablist"
      className="tabs tabs-bordered !border-b-[1px] !border-[#E3E3E3]"
    >
      {tabs.map((title, index) => (
        <Link
          to={`/${title}`}
          key={index}
          role="tab"
          className={`tab uppercase font-semibold tracking-widest text-[12px] leading-6 pt-3 pb-2 h-auto text-[#1E1E1E] !border-b-[4px] ${
            currentTab === title
              ? theme === "staff"
                ? "!border-[#1877D3]"
                : "!border-[#EAAA00]"
              : "!border-transparent"
          }`}
          onClick={() => setCurrentTab(title)}
          state={{ selectedParticipant }}
        >
          {title}
        </Link>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentTab: PropTypes.string.isRequired,
  setCurrentTab: PropTypes.func.isRequired, // Add this to PropTypes
};

export default Tabs;
